<template>
  <v-card class="mx-auto ma-2" max-width="400" min-width="300">
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="headline">Shirts</v-list-item-title>
        <v-list-item-subtitle class="display-3 mt-5">{{ summary.shirts.total }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
        <thead>
            <tr>
                <th class="text-left"></th>
                <th class="text-left">M</th>
                <th class="text-left">F</th>
                <th class="text-left">Skupaj</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>S</td>
                <td>{{ summary.shirts.mS }}</td>
                <td>{{ summary.shirts.fS }}</td>
                <td>{{ summary.shirts.s }}</td>
            </tr>
            <tr>
                <td>M</td>
                <td>{{ summary.shirts.mM }}</td>
                <td>{{ summary.shirts.fM }}</td>
                <td>{{ summary.shirts.m }}</td>
            </tr>
            <tr>
                <td>L</td>
                <td>{{ summary.shirts.mL }}</td>
                <td>{{ summary.shirts.fL }}</td>
                <td>{{ summary.shirts.l }}</td>
            </tr>
            <tr>
                <td>XL</td>
                <td>{{ summary.shirts.mXL }}</td>
                <td>{{ summary.shirts.fXL }}</td>
                <td>{{ summary.shirts.xL }}</td>
            </tr>
        </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-divider></v-divider>

  </v-card>
</template>

<script>
  export default {
    name: 'FCCCompetitionShirts',
    props: {
      summary: Object,
      reload: Function
    },
  }
</script>